import React, { useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Phone, Shield, Truck, Wrench } from 'lucide-react';
import { Button } from '../components/ui/button';
import Layout from '../components/layout/Layout';
import { citiesData } from '../data/cities';

const CityPage = () => {
  const { citySlug } = useParams();
  const navigate = useNavigate();
  const city = citiesData[citySlug];

  useEffect(() => {
    if (!city) navigate('/');
    window.scrollTo(0, 0);
  }, [city, navigate]);

  if (!city) return null;

  const products = [
    { id: 'standart', name: 'Стандарт', price: 20000 },
    { id: 'standart-usilennaya', name: 'Стандарт Усиленная', price: 21500 },
    { id: 'bogatyr', name: 'Богатырь', price: 23500 },
    { id: 'premium', name: 'Премиум', price: 29000 }
  ];

  return (
    <Layout>
      <Helmet>
        <title>{city.metaTitle}</title>
        <meta name="description" content={city.metaDescription} />
      </Helmet>

      <section className="bg-gradient-to-r from-emerald-600 to-emerald-700 text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl md:text-5xl font-bold mb-4">{city.h1}</h1>
          <p className="text-xl mb-6">Доставка по г. {city.name} и {city.region}</p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a href={'tel:' + city.phone.replace(/-/g, '')}>
              <Button size="lg" className="bg-white text-emerald-700 h-14 px-8">
                <Phone className="w-5 h-5 mr-2" />{city.phone}
              </Button>
            </a>
            <Link to="/catalog">
              <Button size="lg" variant="outline" className="border-white text-white h-14 px-8">
                Каталог
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold text-center mb-8">Почему выбирают нас</h2>
          <div className="grid md:grid-cols-3 gap-6">
            {city.advantages.map((adv, i) => (
              <div key={i} className="bg-white p-6 rounded-xl shadow-md text-center">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  {i === 0 && <Truck className="w-6 h-6 text-emerald-600" />}
                  {i === 1 && <Wrench className="w-6 h-6 text-emerald-600" />}
                  {i === 2 && <Shield className="w-6 h-6 text-emerald-600" />}
                </div>
                <p className="text-lg font-medium">{adv}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold text-center mb-8">Теплицы в г. {city.name}</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {products.map((p) => (
              <div key={p.id} className="bg-white rounded-xl shadow-md overflow-hidden">
                <div className="h-32 bg-emerald-100 flex items-center justify-center">
                  <span className="text-emerald-600 font-bold">{p.name}</span>
                </div>
                <div className="p-4">
                  <h3 className="font-bold mb-1">{p.name}</h3>
                  <p className="text-emerald-600 font-bold text-xl mb-3">от {p.price.toLocaleString()} руб</p>
                  <Link to={'/catalog?category=' + p.id} className="block bg-emerald-600 text-white text-center py-2 rounded-lg">
                    Подробнее
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 bg-emerald-50">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold text-center mb-8">Зона доставки</h2>
          <div className="bg-white p-6 rounded-xl shadow-md max-w-2xl mx-auto">
            <ul className="grid grid-cols-2 gap-3">
              {city.deliveryZones.map((zone, i) => (
                <li key={i} className="flex items-center">
                  <span className="text-emerald-600 mr-2">✓</span> {zone}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="py-16 bg-emerald-700 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl font-bold mb-4">Закажите теплицу сегодня!</h2>
          <a href={'tel:' + city.phone.replace(/-/g, '')}>
            <Button size="lg" className="bg-white text-emerald-700 h-14 px-10 text-xl">
              <Phone className="w-6 h-6 mr-2" />{city.phone}
            </Button>
          </a>
        </div>
      </section>
    </Layout>
  );
};

export default CityPage;
